import {Locales} from "../models/Constants";

export class URLHelper
{
    static set validURLs(value: string[])
    {
        this._validURLs = value;
    }

    private static _validURLs: string[] = [];

    static isURLValid(url: string)
    {
        return (this._validURLs.indexOf(url) > -1);
    }

    static isLinkPartOfURL(link: string, url: string, exactMatch: Boolean = false): boolean
    {
        let urlParts: string[] = url.split("/");
        let linkParts: string[] = link.split("/");

        while (urlParts[urlParts.length] == '') urlParts.pop();
        while (linkParts[linkParts.length] == '') linkParts.pop();

        if (!exactMatch && linkParts.length < urlParts.length)
        {
            urlParts = urlParts.slice(0, linkParts.length);
        }

        return (urlParts.join("/") == linkParts.join("/"));
    }

    static isTypeSelectorURL(url: string): boolean
    {
        const currentURLParts: string[] = url.split("/");
        return (currentURLParts.length == 3);
    }

    static isPageURL(url: string): boolean
    {
        const currentURLParts: string[] = url.split("/");
        return (currentURLParts.length > 3);
    }

    static onlyNthURLPartIsDifferent(oldURL: string, newURL: string, partNumber: number): boolean
    {
        if (oldURL == newURL)
        {
            return false;
        }

        const currentURLParts: string[] = oldURL.split("/");
        const nextURLParts: string[] = newURL.split("/");

        if (currentURLParts.length < partNumber || nextURLParts.length < partNumber)
        {
            return false;
        }

        return (currentURLParts[partNumber] !== nextURLParts[partNumber]);
    }

    //
    // for development only
    static get isLocalDev():boolean {
        return (window.location.href.indexOf("http://localhost:8080/")==0) || (window.location.href.indexOf("http://192.168.178.66:8005/")==0)
    }

    static dev_saveCurrentLocale(locale:string):void {
        localStorage.setItem('locale', locale);
    }

    static dev_lastSavedLocale():string {
        let locale:string = localStorage.getItem('locale');
        return (locale) ? locale : Locales.DE;
    }

    static dev_saveCurrentURL(url:string):void {
        localStorage.setItem('lastURL', url);
    }

    static dev_savedCurrentURL():string {
        let lastURL:string = localStorage.getItem('lastURL');
        return (lastURL) ? lastURL : "/";
    }
}